import { UserRole } from '@common/contracts';
const STORAGE_KEY = 'dnd-editor-identity';
const DEFAULT = { username: '', role: UserRole.Creator, isAdmin: false, isRoot: false, permissions: [] };
/** Builds an Identity from the server's /me response (role derived from isAdmin). */
export function identityFromMe(me) {
    return {
        username: me.username,
        role: me.isAdmin ? UserRole.Admin : UserRole.Creator,
        isAdmin: me.isAdmin,
        isRoot: me.isRoot,
        permissions: Array.isArray(me.permissions) ? me.permissions : [],
    };
}
function load() {
    try {
        const raw = localStorage.getItem(STORAGE_KEY);
        if (raw) {
            const p = JSON.parse(raw);
            const isAdmin = !!p.isAdmin;
            return {
                username: typeof p.username === 'string' ? p.username : '',
                role: isAdmin ? UserRole.Admin : UserRole.Creator,
                isAdmin,
                isRoot: !!p.isRoot,
                permissions: Array.isArray(p.permissions) ? p.permissions : [],
            };
        }
    }
    catch (_a) {
        /* ignore malformed storage */
    }
    return Object.assign({}, DEFAULT);
}
let current = load();
const listeners = new Set();
export function getIdentity() {
    return current;
}
export function setIdentity(next) {
    current = next;
    try {
        localStorage.setItem(STORAGE_KEY, JSON.stringify(next));
    }
    catch (_a) {
        /* ignore storage failures */
    }
    listeners.forEach(listener => listener());
}
/** Reset to the anonymous default (used on logout). */
export function clearIdentity() {
    setIdentity(Object.assign({}, DEFAULT));
}
export function subscribeIdentity(listener) {
    listeners.add(listener);
    return () => listeners.delete(listener);
}
/** UI convenience — the backend is the real enforcement. Root holds everything. */
export function hasPermission(identity, perm) {
    return identity.isAdmin && (identity.isRoot || identity.permissions.includes(perm));
}
